function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { FunctionalLoader } from 'seagull';
import { useOverlayContext, useStore, useStoreActions, useStoreStatic } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { DeclarativeModal } from 'seagull';
import { AgreementStudioTemplateMode } from "./AgreementStudioTemplateMode";
import { makeSentryIgnoredError } from "../ErrorBoundaryPage";
import compact from 'lodash/compact';
import { useOnMount } from "../../hooks/useOnMount";
export default function AgreementStudioTemplates(props) {
  const {
    startLoader,
    stopLoader
  } = useOverlayContext();
  const {
    fetchContacts,
    fetchAgreements,
    fetchProposals,
    fetchLegalTerms,
    fetchFinancialCentsUsers,
    fetchKarbonUsers
  } = useStoreActions();
  const {
    getState
  } = useStoreStatic();
  const legalTermsDocuments = useStore(state => state.legalTerms.data);
  const worksAt = useStore(selectors.user.business);
  const userEmail = useStore(selectors.user.email);
  useOnMount(() => {
    startLoader();
    const requests = compact([fetchLegalTerms(), fetchContacts(), fetchAgreements(), fetchProposals(), selectors.integration.showFinancialCentsIntegration(getState()) && fetchFinancialCentsUsers(), selectors.integration.showKarbonIntegration(getState()) && fetchKarbonUsers()]);
    Promise.all(requests).then(() => stopLoader());
  });
  if (!worksAt || !userEmail) {
    throw makeSentryIgnoredError('noBusiness');
  }
  return legalTermsDocuments ? /*#__PURE__*/React.createElement(DeclarativeModal, {
    isOpen: true,
    content: () => /*#__PURE__*/React.createElement(AgreementStudioTemplateMode, _extends({}, props, {
      template: props.template || null,
      legalTermsDocuments: legalTermsDocuments,
      worksAt: worksAt,
      userEmail: userEmail,
      onUploadLegalTermsDocument: fetchLegalTerms
    }))
  }) : /*#__PURE__*/React.createElement(FunctionalLoader, {
    show: true
  });
}